import axios from 'axios';

export default axios.create();

export const { CancelToken } = axios;
